import React from 'react';
import BirthdayPackages from '../components/BirthdayPackages';
import ContactForm from '../components/ContactForm';
import GoogleMap from '../components/GoogleMap';
import ScrollToTop from '../components/ScrollToTop';

const Packages = () => {
  return (
    <div className="service-page-container">
      <ScrollToTop />
      <BirthdayPackages />
      <ContactForm />
      <GoogleMap />
    </div>
  );
};

export default Packages;